export default function CommonAddContact({ formData, setFormData }) {
  const contactTypeOptions = [
    {
      value: 'owner',
      label: 'Owner',
    },
    {
      value: 'manager',
      label: 'Manager',
    },
    {
      value: 'ad_manager',
      label: 'Advertising Manager',
    },
    {
      value: 'br_manager',
      label: 'Branding Manager',
    },
    {
      value: 'other',
      label: 'Other',
    },
  ];

  const countryCodeOptions = [
    {
      value: '+91',
      label: '+91',
    },
    {
      value: '+10',
      label: '+10',
    },
    {
      value: '+92',
      label: '+92',
    },
    {
      value: '+11',
      label: '+11',
    },
  ];

  const relationshipOptions = [
    {
      value: 'deep',
      label: 'Deep',
    },
    {
      value: 'very deep',
      label: 'Very Deep',
    },
    {
      value: 'limited',
      label: 'Limited',
    },
    {
      value: 'acquaintance',
      label: 'Acquaintance',
    },
    {
      value: 'none',
      label: 'None',
    },
  ];

  const removeContact = (index) => {
    const updatedContactData = formData?.contactData?.filter((_, i) => i !== index);

    // Update the state with the updated contactData array
    setFormData((prevFormData) => ({
      ...prevFormData,
      contactData: updatedContactData,
    }));
    alert('Contact Deleted');
  };

  const handleContactChange = (index, key, value) => {
    let temp = [...formData.contactData];
    temp[index][key] = value;
    setFormData((prevState) => ({
      ...prevState,
      contactData: temp,
    }));
  };

  return (
    <div className="form-group">
      {formData?.contactData?.length > 0 &&
        formData?.contactData?.map((item, index) => {
          return (
            <div ng-repeat="contact1 in model.contacts track by $index" key={index}>
              <div className="row list-group-item" style={{ height: '200px' }}>
                <div className="form-group col-md-2" style={{ marginBottom: '20px' }}>
                  <label>Contact Type</label>
                  <select
                    style={{
                      height: '34px',
                      textAlignLast: 'center',
                      borderRadius: '2px',
                      width: '100%',
                    }}
                    value={formData.contactData[index].contact_type}
                    onChange={(e) => handleContactChange(index, 'contact_type', e.target.value)}
                  >
                    <option value="" disabled="true">
                      Select Option
                    </option>
                    {contactTypeOptions.map((item, key) => {
                      return (
                        <option ng-repeat="ctype in typelist" value={item.value} key={key}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="form-group col-md-2" style={{ marginBottom: '20px' }}>
                  <label>Salutation</label>
                  <select
                    style={{
                      height: '34px',
                      textAlignLast: 'center',
                      borderRadius: '2px',
                      width: '100%',
                    }}
                    ng-model="contact1.salutation"
                  >
                    <option value="" disabled="true">
                      Select Option
                    </option>
                    <option ng-repeat="sal in salutationlist" value="Mr.">
                      Mr.
                    </option>
                    <option ng-repeat="sal in salutationlist" value="Ms.">
                      Ms.
                    </option>
                  </select>
                </div>
                <div className="form-group col-md-2" style={{ marginBottom: '20px' }}>
                  <label>Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name_id"
                    style={{ width: '100%' }}
                    ng-model="contact1.name"
                    placeholder="Name"
                    value={formData.contactData[index].name}
                    onChange={(e) => handleContactChange(index, 'name', e.target.value)}
                  />
                </div>
                <div className="form-group col-md-2" style={{ marginBottom: '20px' }}>
                  <label>STD Code</label>
                  <input
                    type="text"
                    className="form-control"
                    id="stdcode"
                    style={{ width: '100%' }}
                    ng-model="contact1.std_code"
                    placeholder="STD Code"
                    value={formData.contactData[index].std_code}
                    onChange={(e) => handleContactChange(index, 'std_code', e.target.value)}
                  />
                </div>
                <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
                  <label>Phone</label>
                  <input
                    type="number"
                    name="phone_name{{$index}}"
                    onkeydown="javascript: return event.keyCode == 69 ? false : true"
                    className="form-control"
                    id="phone_id"
                    style={{ width: '100%' }}
                    ng-model="contact1.landline"
                    ng-pattern="/^[0-9]{6,9}$/"
                    placeholder="Phone"
                    value={formData.contactData[index].landline}
                    onChange={(e) => handleContactChange(index, 'landline', e.target.value)}
                  />
                  <div
                    ng-show="corporate_form.phone_name{{$index}}.$error.pattern"
                    className="error"
                    style={{ fontSize: '12px' }}
                  >
                    Phone number Invalid
                  </div>
                </div>
                <div
                  className=" form-group col-md-1 glyphicon glyphicon-remove"
                  onClick={() => removeContact(index)}
                ></div>
                <div className="form-group col-md-2" style={{ marginBottom: '20px' }}>
                  <label>Country Code</label>
                  <select
                    style={{
                      height: '34px',
                      textAlignLast: 'center',
                      borderRadius: '2px',
                      width: '100%',
                    }}
                    ng-model="contact1.country_code"
                  >
                    <option value="" disabled="true">
                      Select Option
                    </option>
                    {countryCodeOptions.map((item, key) => {
                      return (
                        <option ng-repeat="ccode in countrycodelist" value={item.value} key={key}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="form-group col-md-2" style={{ marginBottom: '20px' }}>
                  <label>Mobile</label>
                  <input
                    type="number"
                    onkeydown="javascript: return event.keyCode == 69 ? false : true"
                    name="mobile_name{{$index}}"
                    className="form-control"
                    id="mobile_id"
                    ng-model="contact1.mobile"
                    ng-pattern="/^[0-9]{10}$/"
                    placeholder="Mobile"
                    value={formData.contactData[index].mobile}
                    onChange={(e) => handleContactChange(index, 'mobile', e.target.value)}
                  />
                  <div
                    ng-show="corporate_form.mobile_name{{$index}}.$error.pattern"
                    className="error"
                    style={{ fontSize: '12px', width: '100%' }}
                  >
                    Mobile number Invalid
                  </div>
                </div>
                <div className="form-group col-md-2" style={{ marginBottom: '20px' }}>
                  <label>Email</label>
                  <input
                    type="text"
                    name="email_name{{$index}}"
                    className="form-control"
                    id="email_id"
                    style={{ width: '100%' }}
                    ng-model="contact1.email"
                    ng-pattern="/^[a-zA-Z]+[.]?[_a-zA-Z]+[@][a-zA-Z]+[.][a-zA-Z]+$/"
                    placeholder="Email"
                    value={formData.contactData[index].email}
                    onChange={(e) => handleContactChange(index, 'email', e.target.value)}
                  />
                  <div
                    ng-show="corporate_form.email_name{{$index}}.$error.pattern"
                    className="error"
                    style={{ fontSize: '12px', width: '100%' }}
                  >
                    Email Invalid
                  </div>
                </div>
                <div className="form-group col-md-2" style={{ marginBottom: '20px' }}>
                  <label>Relationship Status</label>
                  <select
                    style={{
                      height: '34px',
                      width: '100%',
                      textAlignLast: 'center',
                      borderRadius: '2px',
                    }}
                    ng-model="contact1.relationship_status"
                  >
                    <option value="" disabled="true">
                      Select Option
                    </option>
                    {relationshipOptions.map((item, key) => {
                      return (
                        <option
                          ng-repeat="relationStatus in relationStatusOption"
                          value={item.value}
                          key={key}
                        >
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
                  <label>Comments</label>
                  <textarea
                    rows="2"
                    cols="100"
                    className="field"
                    id="comments"
                    placeholder="Comments"
                    ng-model="contact1.comments"
                    style={{ width: '100%' }}
                    value={formData.contactData[index].comments}
                    onChange={(e) => handleContactChange(index, 'comments', e.target.value)}
                  ></textarea>
                </div>
                <br />
              </div>
            </div>
          );
        })}
      <br />
    </div>
  );
}
